<app-history-list [historyData]="historyData$ | async" [entityType]="entityType" [loading]="loading$ | async">
</app-history-list>
